import Vue from 'vue'
import moment from 'moment';
import categorys from './utils/categorys.js';
import config from './apis/config.js'

Vue.filter('ToDateTime', function (value) {
    return moment(value).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter('ToShortDateTime', function (value) {
    return moment(value).format("YYYY-MM-DD HH:mm");
});
Vue.filter('ToSimpleDateTime', function (value) {
    return moment(value).format("YY-MM-DD HH:mm");
});
Vue.filter('ToMonth', function (value) {
    return moment(value).format("MM月DD日 HH:mm");
});
Vue.filter('ToDate', function (value) {
    return moment(value).format("YYYY-MM-DD");
});
Vue.filter('ToMonthDay', function (value) {
    return moment(value).format("MM-DD");
});
Vue.filter('ToTime', function (value) {
    return moment(value).format("HH:mm");
});
Vue.filter('ToMonthTime', function (value) {
    return moment(value).format("MM-DD HH:mm");
});
Vue.filter('DateFormat', function (value, DateFormat) {
    return moment(value).format(DateFormat);
});
Vue.filter('DiffTime', function (value, end, unit) {
    let startDate = moment(value);
    let endDate = moment(end);
    let diffDate = endDate.diff(startDate);
    let dayS = 1000 * 60 * 60 * 24;

    let times = moment.utc(diffDate % (dayS)).format("HH:mm");
    let howDay = parseInt(diffDate / dayS);
    if (howDay > 0) {
        return howDay + "d " + times;
    } else {
        return times;
    }
});
//获取文件服务器
Vue.filter('ToImgUrl', function (value) {
    var url = config.getUrl("fileUrl", "");
    url = url.substring(0, url.length - 1);
    if (value.indexOf('/') == 0) {
        return url + value;
    }
    return value;
});

function mapCategory(value, categoryName) {
    var category = _.find(categorys[categoryName], o => o.CategoryID == value);
    if (category != null) {
        return category;
    }
    return {};
}
Vue.filter('mapName', function (value, categoryName, defaultResult) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryName"];
    if (mapResult) {
        return mapResult;
    }
    return defaultResult || value;
});
Vue.filter('mapCode', function (value, categoryName) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryCode"];
    if (mapResult) {
        return mapResult;
    }
    return value;
});
Vue.filter('mapTitle', function (value, categoryName, defaultResult) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryTitle"];
    if (mapResult) {
        return mapResult;
    }
    return defaultResult || value;
});
Vue.filter('CategoryTitle', function (value, categoryName) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryTitle"];
    if (mapResult) {
        return mapResult;
    }
    return value;
});
Vue.filter('ToWeek', function (value) {
    let lang = window.localStorage.getItem('lang')
    if (lang == 'en') {
        moment.lang('en', {
            weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        })
    } else {
        moment.lang('cn', {
            weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
        })
    }
    return moment(value).format('dddd')
});
Vue.filter('TrainCodes', function (value) {
    return value.replace(/,/g, '')
});
Vue.filter('filterSeatType', function (value) {
    switch (value) {
        case 'edz':
            return value = '二等座';
        case 'ydz':
            return value = '一等座';
        case 'tdz':
            return value = '特等座';
        case 'swz':
            return '商务座';
        case 'rw':
            return value = '软卧';
        case 'dw':
            return value = '动卧';

        case 'yw':
            return value = '硬卧';
        case 'yz':
            return value = '硬座';

    }

});
Vue.filter('arriveDate', function (value) {
    switch (value) {
        case 0:
            return value = '当日到达';
        case 1:
            return value = '次日到达';
        case 2:
            return value = '第二日到达';
        case 3:
            return '第三日到达';
        case 4:
            return value = '第四日到达';
        case 5:
            return value = '第五日到达';
        case 6:
            return value = '第六日到达';
        case 7:
            return value = '第七日到达';
        case 8:
            return value = '第八日到达';
    }

});
Vue.filter('filterLine', function (value) {
    if (value != undefined) {
        return value.replace(/\\n/g, '')
    }
})
Vue.filter('filterImgFile', function (value) {
    return value.split('/').pop()
});
Vue.filter('default', function (value, defaultValue) {
    if (value && /[^\s]/.test(value)) {
        return value;
    }
    return defaultValue;
})
Vue.filter('DurationTime', function (value) {
    let Hours = parseInt(value / 60);
    let minutes = value % 60;
    return `${Hours}h${minutes}m`
})



// WEBPACK FOOTER //
// ./src/filter.js